import React from 'react';
import { useMetaTags } from '../hooks/useMetaTags';
export function CANoticePage() {
  useMetaTags({
    title: 'CA Notice at Collection | FindOnlineDegrees',
    description: 'Read FindOnlineDegrees’ California Notice at Collection to understand the personal information we collect and your privacy choices.'
  });
  return <div className="min-h-screen bg-gray-100" data-id="element-1215" data-mp="1l6c1pbeh9x74">
      {/* Hero Section */}
      <section className="w-full bg-[#1a2332] text-white py-16 px-4" data-id="element-1216" data-mp="oi5v4ixzwuq7">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1217" data-mp="siy5xgmin7ol">
          <h1 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-1218" data-mp="sjhl4pks7hyx">
            CA Notice At Collection
          </h1>
          <p className="text-gray-300 text-sm" data-id="element-1219" data-mp="xgq3aq5xjm06">Last updated: January 2026</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-1220" data-mp="4tn8o94djvf7">
        <div className="bg-white rounded-lg shadow-sm p-8 md:p-12 space-y-8" data-id="element-1221" data-mp="4t3t2z275j4c">
          <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1222" data-mp="9r5lialiiush">
            <p data-id="element-1223" data-mp="tlapjqqw1row">
              This privacy notice for FindOnlineDegrees.org describes how and
              why we might collect, store, use, and/or share your information
              when you use our services, such as when you:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-1224" data-mp="kqmo6bofou5d">
              <li data-id="element-1225" data-mp="ftw5dgl8vkg9">
                Visit our website, or any website of ours that links to this
                privacy notice
              </li>
              <li data-id="element-1226" data-mp="avkz1fu5rs2s">
                Engage with us in other related ways, including any sales,
                marketing, or events
              </li>
            </ul>
            <p className="font-semibold" data-id="element-1227" data-mp="1umsapsc56gi">
              Questions or concerns? Reading this privacy notice will help you
              understand your privacy rights and choices. If you do not agree
              with our policies and practices, please do not use our services.
            </p>
          </div>

          <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1228" data-mp="1r9ulg4eub6qz">
            <p data-id="element-1229" data-mp="2acmn8mi8qxgw">
              If you are a California resident, the California Consumer Privacy
              Act ("CCPA") requires us to provide you with the following notice
              with information about:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-1230" data-mp="21drgn9babld2">
              <li data-id="element-1231" data-mp="26bb8jc0wnwnh">
                the purpose for which we use each category of "personal
                information" (as defined in the CCPA) we collect; and
              </li>
              <li data-id="element-1232" data-mp="2tzay48mhdh0h">
                the categories of third parties to which we (a) disclose such
                personal information for a business purpose, (b) "share"
                personal information for "cross-context behavioral advertising,"
                and/or (c) "sell" such personal information.
              </li>
            </ul>
          </div>

          {/* Categories of Personal Information */}
          <div data-id="element-1233" data-mp="1dmvrkjy7r49i">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1234" data-mp="1dnf3nk16myfm">
              Categories of Personal Information We Collect
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1235" data-mp="161jmbq1vii7t">
              <p data-id="element-1236" data-mp="1138d9hjekbqn">
                The table below describes the categories of personal information
                we have collected from California consumers in the preceding 12
                months, the sources from which we collected it, our business or
                commercial purposes for collecting it, and the categories of
                third parties to whom we disclose, share, or sell that
                information.
              </p>
            </div>

            <div className="overflow-x-auto mt-6" data-id="element-1237" data-mp="w4x4la4ug7a0">
              <table className="min-w-full border border-gray-300" data-id="element-1238" data-mp="w6hwst3ore4p">
                <thead className="bg-gray-50" data-id="element-1239" data-mp="rdfczcopnj1p">
                  <tr data-id="element-1240" data-mp="rcnftxfgtd9b">
                    <th className="border border-gray-300 px-4 py-3 text-left text-sm font-semibold text-gray-900" data-id="element-1241" data-mp="3omep9km8z3x">
                      Category of Personal Information
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left text-sm font-semibold text-gray-900" data-id="element-1242" data-mp="ccryijhvp8wb">
                      Examples
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left text-sm font-semibold text-gray-900" data-id="element-1243" data-mp="h9ifd91ic8is">
                      Collected?
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left text-sm font-semibold text-gray-900" data-id="element-1244" data-mp="r2z809pwrhkv">
                      Sources
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white" data-id="element-1245" data-mp="1009m02u41kth">
                  <tr data-id="element-1246" data-mp="150nutn3jcysk">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1247" data-mp="1528lh1mqbxl5">
                      <strong data-id="element-1248" data-mp="1a0tm325w8ja4">Identifiers</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1249" data-mp="36sk4ssa220l8">
                      Name, email address, phone number, IP address, device ID
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1250" data-mp="3btrdctk0v3sy">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1251" data-mp="1o62d4ubt2fcu">
                      Directly from you via forms, automatically via cookies
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-1252" data-mp="1f5nr1sr0ow8a">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1253" data-mp="1f6ozrqkk96mu">
                      <strong data-id="element-1254" data-mp="2bud5ta7cl8q1">Personal Information (CA Civil Code)</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1255" data-mp="27uulafjfuznq">
                      Name, contact information, education history
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1256" data-mp="1xvvlznkkcgde">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1257" data-mp="rgl2e0xyu34a">
                      Directly from you via forms
                    </td>
                  </tr>
                  <tr data-id="element-1258" data-mp="nx43wr2bsmnr">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1259" data-mp="nyxak6cxv6vr">
                      <strong data-id="element-1260" data-mp="swysup2jj266">Commercial Information</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1261" data-mp="ex7hkw3erzvv">
                      Records of services considered or obtained
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1262" data-mp="jy4yl5comnvs">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1263" data-mp="9xkw5zdffdbz">
                      From your interactions with our services
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-1264" data-mp="81c4qdz9dfj">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1265" data-mp="8ukfvsl4azs">
                      <strong data-id="element-1266" data-mp="3ideac7kaccpv">Internet/Network Activity</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1267" data-mp="3ndafia4pya70">
                      Browsing history, search history, interaction with website
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1268" data-mp="2yrw0un9ygqo2">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1269" data-mp="3dpev255ejw2w">
                      Automatically via cookies and analytics
                    </td>
                  </tr>
                  <tr data-id="element-1270" data-mp="3mpbdvq5420q1">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1271" data-mp="3morz2iarbsg8">
                      <strong data-id="element-1272" data-mp="3hr9uf43rvze1">Geolocation Data</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1273" data-mp="a8rb4gafbiq">
                      Approximate location based on IP address
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1274" data-mp="3rhbjnz7v3nuj">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1275" data-mp="59braaheurju">
                      Automatically via IP address
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-1276" data-mp="1bqdtfcpk8ocl">
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1277" data-mp="1gml0x9xlu7wn">
                      <strong data-id="element-1278" data-mp="1lmqk01pt6m34">Inferences</strong>
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1279" data-mp="1lkcq3w6v7fx5">
                      Preferences, characteristics, behavior
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1280" data-mp="sz342zzhgjmt">
                      Yes
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-sm" data-id="element-1281" data-mp="xus75dapoinv">
                      Derived from your activity on our services
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Business Purposes */}
          <div data-id="element-1282" data-mp="a57lgmn6b7aw">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1283" data-mp="e8vw5e73qj0d">
              Business or Commercial Purposes for Collection
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1284" data-mp="6obep8y4aqee">
              <p data-id="element-1285" data-mp="1prv3f6zxqp7">
                We collect and use personal information for the following
                purposes:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1286" data-mp="3tsrg050uhlu2">
                <li data-id="element-1287" data-mp="3ov9bcqtv1srv">To provide, improve, and administer our services</li>
                <li data-id="element-1288" data-mp="3oxc1dav0jlwl">
                  To communicate with you, including responding to inquiries
                </li>
                <li data-id="element-1289" data-mp="3f5g2hxl3rrrb">To ensure security and fraud prevention</li>
                <li data-id="element-1290" data-mp="3f3v8qa6m4cui">To comply with legal obligations</li>
                <li data-id="element-1291" data-mp="3a5bl85cdet01">To deliver targeted advertising and marketing</li>
                <li data-id="element-1292" data-mp="364hxpd2ubg7o">To analyze and improve our website performance</li>
                <li data-id="element-1293" data-mp="366chup6af4ap">To connect you with educational institutions</li>
              </ul>
            </div>
          </div>

          {/* Disclosure of Personal Information */}
          <div data-id="element-1294" data-mp="2w7myst2nndsv">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1295" data-mp="2w6txi7mgtgi4">
              Disclosure of Personal Information
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1296" data-mp="3faexi3sdcnad">
              <p data-id="element-1297" data-mp="3fa6ju9of9dy4">
                We may disclose your personal information to the following
                categories of third parties:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1298" data-mp="3o2gt9orhtfeb">
                <li data-id="element-1299" data-mp="3o530toedvuwj">Educational institutions and their partners</li>
                <li data-id="element-1300" data-mp="30dxp9lfh7os1">Service providers (analytics, hosting, marketing)</li>
                <li data-id="element-1301" data-mp="2wccf47ubtolj">Advertising partners and networks</li>
                <li data-id="element-1302" data-mp="2wdx7bqt64vg8">Legal and regulatory authorities when required</li>
                <li data-id="element-1303" data-mp="3acwv6w8ux6bc">Business partners in connection with business transfers</li>
              </ul>
            </div>
          </div>

          {/* Your Rights */}
          <div data-id="element-1304" data-mp="pkl9ymx01b20">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1305" data-mp="pk1urdyqh0ro">
              Your California Privacy Rights
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1306" data-mp="klrzz4gx826l">
              <p data-id="element-1307" data-mp="22ilmo9cee2nu">As a California resident, you have the following rights:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1308" data-mp="27j9ayn98s5ed">
                <li data-id="element-1309" data-mp="27gn3enmcppw5">
                  <strong data-id="element-1310" data-mp="1tiyjbi03yms5">Right to Know:</strong> Request disclosure of the
                  categories and specific pieces of personal information we have
                  collected about you.
                </li>
                <li data-id="element-1311" data-mp="2m743a2jc87qx">
                  <strong data-id="element-1312" data-mp="2m8oxts5njqos">Right to Delete:</strong> Request deletion of your
                  personal information, subject to certain exceptions.
                </li>
                <li data-id="element-1313" data-mp="2ci2m49123kbd">
                  <strong data-id="element-1314" data-mp="2cim5lu6cugri">Right to Correct:</strong> Request correction of
                  inaccurate personal information.
                </li>
                <li data-id="element-1315" data-mp="2het2yykoqjxu">
                  <strong data-id="element-1316" data-mp="356i1iwo3o4n8">Right to Opt-Out:</strong> Opt out of the "sale" or
                  "sharing" of your personal information for cross-context
                  behavioral advertising.
                </li>
                <li data-id="element-1317" data-mp="3jtqh09ofyw50">
                  <strong data-id="element-1318" data-mp="3js5o0ohrzl99">Right to Limit:</strong> Limit the use and disclosure
                  of sensitive personal information (if applicable).
                </li>
                <li data-id="element-1319" data-mp="39ur5mjcakmeb">
                  <strong data-id="element-1320" data-mp="39u7ylxo6jif2">Right to Non-Discrimination:</strong> You will not
                  receive discriminatory treatment for exercising your privacy
                  rights.
                </li>
              </ul>
            </div>
          </div>

          {/* How to Exercise Rights */}
          <div data-id="element-1321" data-mp="2w3cmmcidwl79">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1322" data-mp="2w2kz7oyxxts2">
              How to Exercise Your Rights
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1323" data-mp="2r4syc5gbixbq">
              <p data-id="element-1324" data-mp="2m6hse5t596ys">
                To exercise your rights under the CCPA, please contact us
                through the information provided on our website. We will verify
                your identity before processing your request and respond within
                the timeframes required by law.
              </p>
            </div>
          </div>

          {/* Contact Us */}
          <div data-id="element-1325" data-mp="wnrrzak8xp9u">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1326" data-mp="wn9s83ydksx6">
              Contact Us
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1327" data-mp="11op8zjtisd9r">
              <p data-id="element-1328" data-mp="16mquebef4ooe">
                If you have questions about this notice or wish to exercise your
                California privacy rights, please contact us through the
                information provided on our website.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}